/*
 LinksAplikacje

 "Linki" do aplikacji
  
 historia: 
  PM 2021-09-07 - start
*/

import * as React from 'react';

import { withStyles, WithStyles } from '@material-ui/core/styles';
import { Button, Theme, Typography } from '@material-ui/core';
import ImgIcon from './ImgIcon';
import { Aplikacja } from '../App';

//PM 2021-09-08
//zmiana aplikacja na obiekt
interface LinksAplikacjeProps {
  setAplikacja: (aAplikacja: Aplikacja) => void
}

const aplikacje = [
  {
    text: 'mAlert',
    value: 'mAlert',
    src: 'img/mAlert/ic_launcher.png'
  },
  {
    text: 'mBookuj',
    value: 'mBookuj',
    src: 'img/mBookuj/ic_launcher.png'
  },
  {
    text: 'mCzytnik',
    value: 'mCzytnik',
    src: 'img/mCzytnik/ic_launcher.png'
  },
  {
    text: 'mGłosowanie',
    value: 'mGlosowanie',
    src: 'img/mGlosowanie/ic_launcher.png'
  },
  {
    text: 'mGrafik',
    value: 'mGrafik',
    src: 'img/mGrafik/ic_launcher.png'
  },
  {
    text: 'mKelner',
    value: 'mKelner',
    src: 'img/mKelner/ic_launcher.png'
  },
  {
    text: 'mKelnerAuto',
    value: 'mKelnerAuto',
    src: 'img/mKelner/ic_launcher.png'
  },
  {
    text: 'mManager',
    value: 'mManager',
    src: 'img/mManager/ic_launcher.png'
  },
  {
    text: 'mNadzorca',
    value: 'mNadzorca',
    src: 'img/mNadzorca/ic_launcher.png'
  },
  {
    text: 'mPager',
    value: 'mPager',
    src: 'img/mPager/ic_launcher.png'
  },
  {
    text: 'mSms',
    value: 'mSms',
    src: 'img/mSms/ic_launcher.png'
  },
  {
    text: 'mSmsWeb',
    value: 'mSmsWeb',
    src: 'img/mSmsWeb/ic_launcher_round.png'
  },
  {
    text: 'mZałoga',
    value: 'mZaloga',
    src: 'img/mZałoga/ic_launcher_round.png'
  },
]

class LinksAplikacje extends React.Component<LinksAplikacjeProps & WithStyles<typeof styles>, any> {

  //PM 2021-09-08
  //zmiana aplikacja na obiekt
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
        {aplikacje.map((aplikacja, index) => (
          <Typography key={aplikacja.text} variant="h6" component="h2" style={{ paddingTop: "5px", paddingBottom: (index + 1) === aplikacje.length ? "5px" : '' }}>
            {'- '}
            <Button
              variant="text"
              color="secondary"
              size="large"
              onClick={() => this.props.setAplikacja(aplikacja)}
              className={`${classes.link} ${classes.button}`}
              startIcon={<ImgIcon src={aplikacja.src} alt={aplikacja.text} disablePadding />}
            >
              {aplikacja.text}
            </Button>
          </Typography>
        ))}
      </React.Fragment>
    );
  }
}

const styles = (theme: Theme) => ({
  link: {
    textDecoration: "none",
    "&:hover": {
      textDecoration: "underline"
    }
  },
  button: {
    padding: 0,
    fontSize: '12px',
    lineHeight: '19.2px',
    letterSpacing: '0.09px',
    textTransform: 'none' as 'none',
    minWidth: 0,
    "&:hover": {
      background: 'none'
    }
  }
});

export default withStyles(styles)(LinksAplikacje);
